export interface EmailTemplateDto {
  Oid: string;
  Name: string;
  TemplateType: string;
  SubjectLine: string;
  FromName: string;
  FromEmail: string;
  IsDefault: boolean;
  IsActive: boolean;
  CreatedAt: string;
  UpdatedAt: string;
}

export interface EmailTemplateDetailDto extends EmailTemplateDto {
  DesignJson: string;
  HtmlContent: string;
}

export interface EmailTemplateSaveRequest {
  Name: string;
  TemplateType: string;
  SubjectLine: string;
  DesignJson: string;
  HtmlContent: string;
  FromName: string;
  FromEmail: string;
  IsDefault: boolean;
}

export interface PlaceholderItem {
  Key: string;
  Label: string;
}

export interface PlaceholderGroup {
  Group: string;
  Items: PlaceholderItem[];
}

export const TEMPLATE_TYPE_LABELS: Record<string, string> = {
  MaintenanceReport: 'Onderhoudsrapport',
  WorkOrderConfirmation: 'Werkbon bevestiging',
  WorkTaskNotification: 'Opdracht notificatie',
  Quotation: 'Offerte',
  AppointmentReminder: 'Afspraak herinnering',
};
